<template>
  <div>
    <roles-form
      :is-active.sync="isEditing"
      method="put"
      :staff="editingStaff"
      @changed="staffUpdated"
    />
    <roles-form :is-active.sync="isAdding" @changed="roleAdded" />
    <user-role-form
      :staff="currentStaff"
      @changed="staffUpdated"
      :is-active.sync="isCurrentStaff"
    />
    <data-table
      title="Staff"
      ref="table"
      :url="url"
      :headers="headers"
      :archive="false"
      item-key="id"
      searchable
    >
      <v-btn slot="action.icons" color="primary" @click="isAdding = true">
        Add New Staff
        <v-icon class="ml-2" color="light-blue lighten-4"> mdi-account-money</v-icon>
      </v-btn>

      <template slot="item.actions" slot-scope="{ item }">
        <div class="d-flex">
          <v-btn small icon @click="updateStaff(item)">
            <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn small icon @click="showPermissionsModal(item)">
            <v-icon>mdi-eye-outline</v-icon>
          </v-btn>
        </div>
      </template>
    </data-table>
  </div>
</template>
<script>
import RolesForm from "./form";
import UserRoleForm from "./userrole.vue";

export default {
  components: {
    RolesForm,
    UserRoleForm,
  },
  data() {
    return {
      isAdding: false,
      isEditing: false,
      isCurrentStaff: false,
      staff: {},
      editingStaff: null,
      currentStaff: null,
      url: "/api/v1/staff",
      headers: {
        "user.full_name": "Name",
        role: "Role",
        department: "Department",
        actions: "Actions",
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    roleAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    staffUpdated({ message }) {
      this.editingStaff = null;
      this.currentStaff = null;
      this.isEditing = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateStaff(staff) {
      this.editingStaff = Object.assign({}, staff);
      this.isEditing = true;
    },
    showPermissionsModal(staff) {
      this.currentStaff = Object.assign({}, staff);
      this.isCurrentStaff = true;
    },
  },
};
</script>
